<template>
<section>
  <store-selector />
  <draft-issue-filters />
  <div>

    <b-row>
      <b-col cols="6">
        <h3 class="card-title mb-4">Customer Draft Issues </h3>
      </b-col>
      <b-col cols="6">
        <section class="clearfix">
          <b-pagination class="float-right" v-if="drafts.length > 0" :total-rows="paginate.count" v-model="paginate.page" :per-page="paginate.pageSize" @input="changePage">
          </b-pagination>
        </section>
      </b-col>
    </b-row>
    
    <div class="text-center" v-if="inProgress">
      <b-spinner label="Spinning" variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
    </div>
    <section class="drafts" v-if="drafts.length > 0">
      <single-draft-with-issue v-for="draft in drafts" :orderPrefix="store ? store.orderPrefixArray[0] : ''" v-bind:key="draft.id" :draft="draft" :users="users" :statuses="draftIssueStatuses" :send-for-print-status-id="sentForPrintStatusId"
      
      />
    </section>
    <b-alert variant="primary" show v-else>
        No draft with customer redesign requests found.
    </b-alert>
    
    <div class="clearfix">
      <b-pagination class="float-right" v-if="drafts.length > 0" :total-rows="paginate.count" v-model="paginate.page" :per-page="paginate.pageSize" >
      </b-pagination>
    </div>
    
   
  </div>
  <customer-draft-slide-out />
</section>
</template>

<script>
const SingleDraftWithIssue = () => import( /* webpackChunkName: "drafts.single-draft-with-issue"*/ './single-draft-with-issue')
const StoreSelector = () => import( /* webpackChunkName: "store.selector" */ '../../../components/dashboard-widgets/store-selector')

const DraftIssueFilters = () => import( /* webpackChunkName: "drafts.issue-filters" */ './draft-issue-filters')
const CustomerDraftSlideOut = () => import(/* webpackChunkName: "orders.customer-draft-slideout" */ '../../orders/customer-drafts/customer-draft-slideout')

import CustomerDraftsService from '../../../services/customer-drafts.service'

import EventBus from '../../../EventBus';

export default {
  data() {
    return {
      drafts: [],
      users: [],
      draftIssueStatuses: [],
      paginate: {
        count: 0,
        page: 1,
        pageSize: 10
      },
      store: null,
      inProgress: false
    }
  },
  components: {
    SingleDraftWithIssue,
    StoreSelector,
    DraftIssueFilters,
    CustomerDraftSlideOut
  },
  async mounted() {

    this.fetchDraftWithIssues();

    EventBus.$on('draft-issue-status-updated', () => {
      this.fetchDraftWithIssues();
    });

    EventBus.$on("extra-status-modified", (order) => {
      this.fetchDraftWithIssues();
    })

    EventBus.$on('archived-status-updated-on-draft-response', () => {
        this.fetchDraftWithIssues();
    })

        // Logic to increase count of notes in display
    EventBus.$on('update-note-count', data => {
      
      let particularDraft = this.drafts.find(draft => data.recordId == draft.id);

      particularDraft.UserNotes = [];
      console.log(data.count)
      for (let i = 0; i < data.count; i++) {
        particularDraft.UserNotes.push({})
      }

    })

    this.$store.dispatch('draft/fetchIssueStatuses')
    this.$store.dispatch('draft/fetchCompanyUsers')
  },
  computed: {
    storeInState() {
      return this.$store.state.ecommerceStore.store
    },
    searchStatusIdsArray(){
      return this.$store.state.draft.searchData.statusesId
    },
    designerToSearch(){
      return this.$store.state.draft.searchData.userId
    },
    approvalStatusInState(){
      return this.$store.state.draft.searchData.approvalStatus
    },
    orderIdsFromState(){
      return this.$store.state.draft.searchData.orderIds
    },
    sentForPrintStatusId(){
       const sentForPrintRecord = this.extraStatusesOfStore.find(status => status.name == 'Send for Print')
       if(sentForPrintRecord){
          return sentForPrintRecord.id
       }else{
         return null;
       }
    },
    draftUploaderFromState(){
       return this.$store.state.draft.searchData.uploaderNames
    },
    includeArchivedStatusFromState(){
      return this.$store.state.draft.searchData.includeArchived
    },
    draftSentDateFromState(){
      return this.$store.state.draft.searchData.draftSentDate
    },
    draftResponseDateFromState(){
      return this.$store.state.draft.searchData.draftResponseDate
    },
  },
  methods: {
    resetPagination(){
       this.paginate.count = 0;
       this.paginate.page = 1;
    },
    async fetchDraftWithIssues() {

      try {
        if (this.storeInState.id) {

          let data = {
            storeId: this.storeInState.id,
            issueStatusIds: this.searchStatusIdsArray,
            paginate: this.paginate,
            userId: this.designerToSearch,
            approvalStatus: this.approvalStatusInState,
            orderNos: this.orderIdsFromState,
            draftUploaders: this.draftUploaderFromState,
            includeArchived: this.includeArchivedStatusFromState,
            draftSentDate: this.draftSentDateFromState,
            draftResponseDate: this.draftResponseDateFromState
          }
          this.inProgress = true;
          const drafts = await CustomerDraftsService.fetchDraftWithIssues(data)
          this.drafts = drafts.data.draftsWithIssues.rows
          this.store = drafts.data.store
          this.extraStatusesOfStore = drafts.data.store.ExtraStatuses
          this.paginate.count = drafts.data.draftsWithIssues.count
          this.inProgress = false;
          console.log('Resolved matter')
        }
      } catch (e) {
        console.log(e)
        this.inProgress = false;
      }

    },
    async changePage() {
      try {
        await this.fetchDraftWithIssues();
      } catch (e) {
        console.log(e)
      }
    },
  },
  watch: {
    storeInState(newValue, oldValue) {
      console.log('New value', newValue);
      if (newValue != oldValue) {
        console.log("it's fired")
        this.fetchDraftWithIssues()
      }

    },
    searchStatusIdsArray(newValue, oldValue){
      this.resetPagination()
      this.fetchDraftWithIssues()
    },
    designerToSearch(newValue, oldValue){
      this.resetPagination()
      this.fetchDraftWithIssues()
    },
    approvalStatusInState(newValue, oldValue){
      this.resetPagination()
      this.fetchDraftWithIssues()
    },
    orderIdsFromState(newValue){
      this.resetPagination()
      this.fetchDraftWithIssues()
    },
    draftUploaderFromState(newValue){
      this.resetPagination()
      this.fetchDraftWithIssues()
    },
    includeArchivedStatusFromState(newValue){
      this.resetPagination()
      this.fetchDraftWithIssues()
    },
    draftSentDateFromState(newValue){
      this.resetPagination()
      this.fetchDraftWithIssues()
    },
    draftResponseDateFromState(newValue){
      this.resetPagination()
      this.fetchDraftWithIssues()
    }
  },
  beforeDestroy(){
    EventBus.$off('draft-issue-status-updated')
    EventBus.$off("extra-status-modified")
    EventBus.$off('archived-status-updated-on-draft-response')
    EventBus.$off('update-note-count')
  }
}
</script>

<style lang="scss" scoped>

</style>
